// extracted by mini-css-extract-plugin
export default {"Tabs":"ysxXW23ym_p2dyVnJOYF","TabListWrapper":"OQwJtszmWf9OhxFln_ZO","TabPanels":"e253euFM8WPdEiyeRI4s","Header":"op33_PrNDy6SDWX68HHZ","Header--wrapped":"jwNnKIORFrQ4YEN6mViQ"};